﻿<template>
  <div id="quickquote-pet-step-1-component">
    <h1 data-test="quickquote-pet-headline" v-html="contentModel.SharedFields.LabelHeadingStep1" />
    <section>
      <article class="flow-group">
        <div class="control row">
          <div class="small-12 medium-8 columns">
            <h-3-and-tooltip
              :h3="contentModel.LabelPetBreed"
              data-test="quickquote-pet-headline-breed"
              :tooltip="contentModel.TooltipPetBreed"
            />
            <Field
              v-model="vueModelData.TemplateModel.Breed"
              :rules="'required'"
              label="Race"
              name="Breed"
              v-slot="{ field }"
            >
              <VueSelect
                :name="field.name"
                v-model="vueModelData.TemplateModel.Breed"
                :options="contentModel.MultilistPetBreeds.DropdownElements"
                :reduce="(option) => option.Value"
                label="Name"
                :placeholder="contentModel.PlaceholderPetBreed"
                data-test="quickquote-pet-select-breed"
                @click.native="activityInBreedField"
              />
            </Field>
            <ValidationError name="Breed" />
          </div>
        </div>
        <div class="control row">
          <div class="small-12 medium-6 columns">
            <h-3-and-tooltip
              id="petBirthday"
              :h3="contentModel.LabelPetBirthdate"
              data-test="quickquote-pet-headline-birth-date"
              :tooltip="contentModel.TooltipPetBirthdate"
            />

            <Field
              name="BirthDate"
              v-model="vueModelData.TemplateModel.Birthday"
              rules="required"
              label="Fødselsdag"
            >
              <date-picker
                id="birthdate"
                v-model="vueModelData.TemplateModel.Birthday"
                class="datepicker"
                :placeholder="contentModel.PlaceholderPetBirthdate"
                :date="vueModelData.TemplateModel.Birthday"
                :max-date="tomorrow"
                data-test="quickquote-pet-input-date"
                save-format="YYYY-MM-DD"
                aria-labelledby="petBirthdaySpan"
              />
            </Field>
            <ValidationError name="BirthDate" />
          </div>
        </div>
        <div class="control row">
          <div class="small-12 medium-6 columns">
            <h-3-and-tooltip
              id="petname"
              :h3="contentModel.LabelPetName"
              data-test="quickquote-pet-headline-name"
              :tooltip="contentModel.TootipPetName"
            />

            <Field name="Name" rules="required" label="Navn" v-model="vueModelData.TemplateModel.Name" v-slot="{ field }">
              <input
                id="name"
                v-bind="field"
                type="text"
                class="input"
                :placeholder="contentModel.PlaceholderPetName"
                data-test="quickquote-pet-input-name"
                aria-labelledby="petnameSpan"
              />
            </Field>
            <ValidationError name="Name" />
          </div>
        </div>
        <fieldset class="control" style="margin:0 0 0">
          <legend style="margin-bottom: 0">
          <h-3-and-tooltip
            :h3="contentModel.LabelPetGender"
            data-test="quickquote-pet-headline-gender"
            :tooltip="contentModel.TooltipPetGender"
          />
        </legend>
          <div class="row">
            <div
              v-for="(gender, index) in contentModel.MultilistPetGenders.DropdownElements"
              :key="index"
              class="small-12 medium-6 columns"
            >
              <div class="radio-stacked">
                <Field
                  :id="gender.Value"
                  v-model="vueModelData.TemplateModel.Gender"
                  :rules="'required'"
                  type="radio"
                  name="Gender"
                  :value="gender.Value"
                  label="Køn"
                  :data-test="'quickquote-pet-input-gender-' + gender.Name"
                />
                <label :for="gender.Value" v-html="gender.Name" />
              </div>
            </div>
            <div class="small-12 columns">
              <ValidationError name="Gender" />
            </div>
          </div>
        </fieldset>
        <fieldset class="control" style="margin:0 0 0">
          <legend style="margin-bottom: 0">
            <h-3-and-tooltip
              :h3="contentModel.LabelPetNeutered"
              data-test="quickquote-pet-headline-neutered"
              :tooltip="contentModel.TooltipPetNeutered"
            />
          </legend>
          <div class="row">
            <div class="small-12 medium-6 columns">
              <div class="radio-stacked">
                <Field
                  id="neuteredNo"
                  v-model="vueModelData.TemplateModel.NeuteredStatus"
                  :rules="'required'"
                  type="radio"
                  name="Neutered"
                  value="0"
                  :label="contentModel.FieldNamePetNeutered"
                />
                <label for="neuteredNo" v-html="contentModel.SharedContent.LabelNo" />
              </div>
            </div>
            <div class="small-12 medium-6 columns">
              <div class="radio-stacked">
                <input
                  id="neuteredYes"
                  v-model="vueModelData.TemplateModel.NeuteredStatus"
                  :rules="'required'"
                  type="radio"
                  name="Neutered"
                  value="1"
                  label="contentModel.FieldNamePetNeutered"
                />
                <label for="neuteredYes" v-html="contentModel.SharedContent.LabelYes" />
              </div>
            </div>
            <div class="small-12 columns">
              <ValidationError name="Neutered" />
            </div>
          </div>
        </fieldset>
        <hr />
        <div class="control">
          <questionnaire
            :options="assetQuestions"
            :always-show="true"
            :heading-three="true"
            @questionnaire-updated="getQuestionnaireAnswersFromId"
          />
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import Utility from '@/common/UtilityFunctions.js';
import QuickQuoteMixin from './QuickQuoteMixin.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import DatePicker from '@/components/UI/Pickadate.vue';

export default {
  name: 'PetProposal',
  components: { H3AndTooltip, DatePicker },
  emits: ['disable-next-button', 'update-personal-information'],
  mixins: [QuickQuoteMixin],
  props: {
    contentModel: {
      type: Object,
      default() {
        return {};
      }
    },
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    stepModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      isBlocked: false,
      tomorrow: moment(),
      vueModelData: this.vueModel
    };
  },
  computed: {
    personalInformationForTagManager() {
      return {
        event: 'track-event',
        eventCategory: this.getDanishProductTypeName + ' prisberegner',
        eventAction: '01 oplysninger submit ok',
        eventLabel: 'oplysninger submit ok',
        eventValue: '0',
        eventNoninteraction: true,
        data: {
          breed: this.vueModelData.TemplateModel.Breed
        }
      };
    }
  },
  watch: {
    personalInformationForTagManager() {
      this.$emit('update-personal-information', this.personalInformationForTagManager);
    }
  },
  methods: {
    updateBlockStatus() {
      if (!this.isBlocked) {
        this.$emit('disable-next-button', false);
      }
    },
    getQuestionnaireAnswersFromId(param) {
      if (param.answer.Block) {
        this.$emit('disable-next-button', true);
        this.showErrorModal();
      }
      this.isBlocked = param.blockStatus;
      this.updateBlockStatus();
    },
    activityInBreedField() {
      Utility.pushToTagManager({
        event: 'track-ga-vp',
        virtualPath: '/virtual/engagement/hund-prisberegner-01-racefelt-forladt',
        virtualTitle: 'Virtuel - Beregn pris - Hund - racefelt aktivitet'
      });
    }
  }
};
</script>
